// Every date and time in the app is shown in India time (Asia/Kolkata),
// as DD/MM/YYYY and 12-hour with AM/PM.
export const TZ = "Asia/Kolkata";

const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

const parse = (v) => {
  if (!v) return null;
  if (v instanceof Date) return isNaN(v) ? null : v;
  const s = String(v);
  if (DATE_ONLY.test(s)) return new Date(`${s}T00:00:00+05:30`);
  const d = new Date(s);
  return isNaN(d) ? null : d;
};

const parts = (d) => {
  const f = new Intl.DateTimeFormat("en-GB", {
    timeZone: TZ, day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit", hour12: true,
  }).formatToParts(d).reduce((a, p) => ({ ...a, [p.type]: p.value }), {});
  return f;
};

/** 23/06/2026 */
export const fmtDate = (v, fallback = "—") => {
  const d = parse(v);
  if (!d) return fallback;
  const p = parts(d);
  return `${p.day}/${p.month}/${p.year}`;
};

/** 07:45 pm */
export const fmtTime = (v, fallback = "—") => {
  const d = parse(v);
  if (!d) return fallback;
  const p = parts(d);
  return `${p.hour}:${p.minute} ${p.dayPeriod}`;
};

/** 23/06/2026, 07:45 pm */
export const fmtDateTime = (v, fallback = "—") => {
  const d = parse(v);
  if (!d) return fallback;
  return `${fmtDate(d)}, ${fmtTime(d)}`;
};

/** today in India, as YYYY-MM-DD for <input type="date"> */
export const todayIST = () => {
  const p = parts(new Date());
  return `${p.year}-${p.month}-${p.day}`;
};
